import React from 'react';
import './RecentSheetsSidebar.css';
import sheetMapIcon from '../icons/SheetMapIcon.png';

function RecentSheetsSidebar({ recentMaps, onLoadMap, onPinMap, iconSrc }) {
  const displayIcon = iconSrc || sheetMapIcon;
  const handleLoadRecent = (savedMap) => {
    onLoadMap(savedMap);
  };

  const handlePin = async (e, savedMap) => {
    e.stopPropagation();
    try {
      await onPinMap(savedMap);
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <div className="recent-sheets-sidebar">
      <div className="sidebar-header">
        <h3>Recent Maps</h3>
        <span className="recent-count">{recentMaps.length}</span>
      </div>

      <div className="recent-sheets-list">
        {recentMaps.length === 0 ? (
          <div className="empty-recent">
            <p>No recent maps yet</p>
            <p className="help-text">Load a map to see it here</p>
          </div>
        ) : (
          recentMaps.map((savedMap, index) => (
            <div
              key={`recent-${index}`}
              className="recent-sheet-item"
              onClick={() => handleLoadRecent(savedMap)}
            >
              <div className="recent-item-content">
                <div className="recent-item-icon-section">
                  <div className="recent-item-icon">
                    <img src={displayIcon} alt="Map" />
                  </div>
                  <button
                    className="pin-button"
                    onClick={(e) => handlePin(e, savedMap)}
                    title="Pin this map"
                  >
                    📌
                  </button>
                </div>
                <div className="recent-item-info">
                  <div className="recent-item-name">{savedMap.sheetName}</div>
                  <div className="recent-item-tab">{savedMap.tabName}</div>
                  <div className="recent-item-date">
                    {new Date(savedMap.lastAccessed).toLocaleDateString()}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default RecentSheetsSidebar;
